export const DETAILS = 'DETAILS';
export const CITIES = 'CITIES';
